import React from 'react';
import BlankHome from './BlankHome';
import PetTaxiDeSuccess from './PetTaxiDeSuccess';
import { isPetTaxiPublicSite } from '../petTaxiLocales';

/** Корень сайта: zoo-taxi.com → публичная витрина, иначе пустая заглушка. */
function PetTaxiHomeGate() {
  if (isPetTaxiPublicSite()) {
    return <PetTaxiDeSuccess />;
  }
  return <BlankHome />;
}

export default PetTaxiHomeGate;
